import { AdminActionButton } from '../admin-action-button';
import { AdminActionButtonItem } from '../admin-action-button-item';
import { AdminEventPanelActionButtonProps } from './admin-event-panel-action-button-props';
import React from 'react';
import { useAdminEventPanelController } from './use-admin-event-panel-controller';

export const AdminEventPanelActionButton: React.FunctionComponent<
  AdminEventPanelActionButtonProps
> = props => {
  const {
    editingEvent,
    onSaveClick,
    onDiscardClick,
  } = useAdminEventPanelController(props.eventKey);

  const createLabel = editingEvent ? 'Update Event' : 'Create Event';

  return (
    <AdminActionButton label={createLabel} onClick={onSaveClick}>
      <AdminActionButtonItem onClick={onSaveClick}>
        {createLabel}
      </AdminActionButtonItem>
      <AdminActionButtonItem color="danger" onClick={onDiscardClick}>
        {editingEvent ? 'Discard Changes' : 'Discard Event'}
      </AdminActionButtonItem>
    </AdminActionButton>
  );
};
